import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../components/UI/Button';
import ResumePreview from '../../components/Resume/ResumePreview';
import * as resumeService from '../../services/resumeService';
import { exportToPDF } from '../../utils/exportPDF';
import { exportToDOCX } from '../../utils/exportDOCX';

export default function ResumePreviewPage() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [resume, setResume] = useState(null);
	const [zoom, setZoom] = useState(1);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		(async () => {
			try {
				const res = await resumeService.getResumeById(id);
				setResume(res.resume);
			} catch {
			} finally {
				setLoading(false);
			}
		})();
	}, [id]);

	if (loading || !resume) return null;

	const filenameBase = (resume.title || 'resume').replace(/[^a-z0-9-_]+/gi, '_');

	return (
		<div className="min-h-screen bg-gray-50">
			<div className="sticky top-0 bg-white border-b">
				<div className="max-w-7xl mx-auto px-4 h-14 flex items-center justify-between">
					<div className="flex items-center gap-2">
						<Button variant="ghost" onClick={() => navigate(-1)}>
							Back
						</Button>
						<h1 className="font-semibold">{resume.title}</h1>
						{typeof resume.atsScore === 'number' && <span className="ml-2 text-sm text-gray-600">ATS {resume.atsScore}%</span>}
					</div>
					<div className="flex items-center gap-2">
						<button className="p-1 rounded hover:bg-gray-100" onClick={() => setZoom((z) => Math.max(0.5, z - 0.1))}>-</button>
						<button className="p-1 rounded hover:bg-gray-100" onClick={() => setZoom((z) => Math.min(1.5, z + 0.1))}>+</button>
						<Button variant="ghost" onClick={() => exportToPDF('resume-preview', `${filenameBase}.pdf`)}>Export PDF</Button>
						<Button variant="ghost" onClick={() => exportToDOCX(resume, `${filenameBase}.docx`)}>Export DOCX</Button>
						<Button variant="secondary" onClick={() => navigate(`/resumes/${resume._id}/edit`)}>Edit</Button>
					</div>
				</div>
			</div>
			<div className="max-w-7xl mx-auto px-4 py-6">
				<ResumePreview resumeData={resume} templateType={resume.templateType} zoom={zoom} />
			</div>
		</div>
	);
}


